import React, { useEffect, useState } from 'react';
import '.././App.css';
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import {
  collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc,
  getDocs, deleteDoc, doc, where, getAggregateFromServer, sum, updateDoc
} from 'firebase/firestore';
import Select from 'react-select';
import moment from 'moment';

function Dashboard() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  const [userData, setUserData] = useState();
  const [products, setproducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null); // customer selection
  const [orderdate, setorderdate] = useState("");
  const [reportData, setreportData] = useState([]);
  const [totalamount, settotalamount] = useState("");
  const [quantity, setquantity] = useState(1);
  const [barcode, setbarcode] = useState("");
  const [item, setitem] = useState("");
  const [stockProducts, setStockProducts] = useState([]);
  const [selectedStockProduct, setSelectedStockProduct] = useState(null);
  const [availableStock, setAvailableStock] = useState(null);

  useEffect(() => {
    auth.onAuthStateChanged((user) => setUserData(user));
  }, []);

  useEffect(() => {
    fetchData();
    fetchCustomers();
    const today = new Date();
    setorderdate(today.toISOString().split('T')[0]);
  }, []);

  const fetchCustomers = async () => {
    try {
      const snap = await getDocs(collection(db, 'customers'));
      const arr = snap.docs.map(d => ({ value: d.id, label: d.data().name, data: d.data() }));
      setCustomers(arr);
    } catch (err) {
      console.error(err);
      Toast.fire({ icon: 'error', title: 'Failed to load customers' });
    }
  };


  const fetchData = async () => {
    try {
      // ------------ FETCH PRODUCTS --------------
      const qProducts = query(
        collection(db, "products"),
        orderBy("prodname", "desc")
      );

      onSnapshot(qProducts, (querySnapshot) => {
        const arr = querySnapshot.docs.map((d) => ({
          id: d.id,
          data: d.data(),
          label: d.data().prodname,
          value: d.id,
          stock: d.data().stock || 0,
        }));

        setproducts(arr);
        setStockProducts(arr); // for stock section
      });



      // ------------ LOAD ALL CUSTOMERS (1 READ ONLY) --------------
      const customerSnap = await getDocs(collection(db, "customers"));
      const customerMap = {};

      customerSnap.forEach((doc) => {
        customerMap[doc.id] = doc.data().name;
      });

      // ------------ FETCH ORDERS --------------
      const fromdate = moment().format("YYYY-MM-DD");
      const todate = moment().format("YYYY-MM-DD");

      const qOrders = query(
        collection(db, "orderitems"),
        orderBy("created", "desc"),
        where("orderdate", ">=", fromdate),
        where("orderdate", "<=", todate)
      );

      onSnapshot(qOrders, (snap) => {
        const temp = [];
        let total = 0;

        snap.docs.forEach((d) => {
          const data = d.data();
          const dealername = customerMap[data.custid] || ""; // Instant Lookup

          if (dealername) {
            total += Number(data.total || 0);
            temp.push({
              id: d.id,
              data,
              dealername,
              datetime: data.created.toDate().toString(),
            });
          }
        });

        setreportData(temp);
        settotalamount(total);
      });
    } catch (error) {
      Toast.fire({ icon: "error", title: error.message });
    }
  };

  const handleSelectItem = (item) => {
    setitem("");
    addOrderItems(item.data.prodname, item.id, item.data.rate, quantity);
  };

  const handleSelectItem1 = async (item) => {
    if (!item) return;
    setbarcode(item);

    const q11 = query(collection(db, 'products'), where("barcode", "==", item));
    const querySnapshot = await getDocs(q11);
    querySnapshot.forEach((doc) => {
      addOrderItems(doc.data().prodname, doc.id, doc.data().rate, quantity);
    });
    setbarcode("");
  };
  const addOrderItems = async (itemName, itemId, rate, quantity) => {
    try {
      // Add order with optional customer
      await addDoc(collection(db, 'orderitems'), {
        itemname: itemName,
        itemid: itemId,
        custid: selectedCustomer ? selectedCustomer.value : null, // store customer id if selected
        customerName: selectedCustomer ? selectedCustomer.label : '', // store customer name if selected
        orderdate,
        quantity: parseFloat(quantity),
        rate: parseFloat(rate),
        total: parseFloat(quantity) * parseFloat(rate),
        uid: userData?.uid || null,
        created: Timestamp.now(),
      });

      // Update product stock
      const prodRef = doc(db, 'products', itemId);
      const prodSnap = await getDoc(prodRef);
      if (prodSnap.exists()) {
        const newstock = parseFloat(prodSnap.data().stock || 0) - quantity;
        await updateDoc(prodRef, { stock: newstock });
      }

      // Update or add product-wise sale
      const q3 = query(collection(db, 'productwisesale'), where("itemid", "==", itemId), where('orderdate', '==', orderdate));
      const saleSnapshot = await getDocs(q3);
      const agg = await getAggregateFromServer(query(
        collection(db, 'orderitems'),
        where("itemid", "==", itemId),
        where('orderdate', '==', orderdate)
      ), { quantity: sum('quantity') });

      if (saleSnapshot.empty) {
        await addDoc(collection(db, 'productwisesale'), {
          itemname: itemName,
          itemid: itemId,
          orderdate,
          rate: parseFloat(rate),
          quantity: agg.data().quantity,
          uid: userData?.uid || null,
          created: Timestamp.now(),
        });
      } else {
        await updateDoc(saleSnapshot.docs[0].ref, { quantity: agg.data().quantity });
      }


      // Reset customer and barcode after order added
      setSelectedCustomer(null);
      setbarcode('');

      fetchData();
    } catch (err) {
      Toast.fire({ icon: "error", title: err.message });
    }
  };


  const handleDelete = async (docid, quantity, itemid) => {
    if (!window.confirm('Are you sure?')) return;

    await deleteDoc(doc(db, 'orderitems', docid));
    Toast.fire({ icon: "success", title: 'Entry Deleted Successfully!!' });

    const q2 = query(collection(db, 'orderitems'), where("itemid", "==", itemid), where('orderdate', '==', orderdate));
    const snapshot = await getAggregateFromServer(q2, { quantity: sum('quantity') });

    const q3 = query(collection(db, 'productwisesale'), where("itemid", "==", itemid), where('orderdate', '==', orderdate));
    const saleSnap = await getDocs(q3);
    if (!saleSnap.empty) {
      await updateDoc(saleSnap.docs[0].ref, { quantity: snapshot.data().quantity });
    }

    fetchData();
  }

  const handleStockSelect = async (product) => {
    if (!product) {
      setSelectedStockProduct(null);
      setAvailableStock(null);
      return;
    }

    setSelectedStockProduct(product);

    // Get fresh stock from Firestore
    const prodRef = doc(db, "products", product.value);
    const prodSnap = await getDoc(prodRef);

    if (prodSnap.exists()) {
      setAvailableStock(prodSnap.data().stock || 0);
    } else {
      setAvailableStock(0);
    }
  };

  return (
    <div>
      <div className="content-wrapper">
        <section className="content">
          <button className="btn btn-secondary " style={{ float: "right", marginTop: 4 }} >|| Dashboard ||</button><br /><br />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="card card-success card-outline mb-3">
              <div className="card-header">
                <h5 className="card-title"><b>Stock Check Section</b></h5>
              </div>

              <div className="card-body">
                <div className="row align-items-end">
                  <div className="col-sm-4">
                    <label>Select Product</label>
                    <Select
                      options={stockProducts}
                      value={selectedStockProduct}
                      onChange={handleStockSelect}
                      placeholder="Select Product to Check Stock"
                    />
                  </div>

                  <div className="col-sm-4">
                    <label>Available Stock</label>
                    <input
                      type="text"
                      className="form-control"
                      value={
                        availableStock !== null
                          ? availableStock
                          : ""
                      }
                      readOnly
                    />
                  </div>

                  <div className="col-sm-4">
                    {availableStock !== null && (
                      <div style={{ marginTop: 30 }}>
                        {availableStock <= 0 ? (
                          <span className="badge bg-danger p-2">
                            Out Of Stock
                          </span>
                        ) : availableStock <= 5 ? (
                          <span className="badge bg-warning p-2">
                            Low Stock
                          </span>
                        ) : (
                          <span className="badge bg-success p-2">
                            In Stock
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="card card-primary card-outline mt-1">
              <div className="card-body table-responsive p-3" >
                <div className='row'>
                  <div className='col-sm-3'>
                    <label>Select Customer</label>
                    <Select
                      options={customers}
                      value={selectedCustomer}
                      onChange={(e) => setSelectedCustomer(e)}
                      placeholder="Select Customer"
                    />
                  </div>
                  <div className='col-sm-3'>
                    <label>Quantity</label>
                    <input className='form-control' value={quantity} onChange={(e) => setquantity(e.target.value)} autoFocus />
                  </div>
                  <div className='col-sm-3'>
                    <label>Enter Barcode</label>
                    <input type='text' className='form-control' placeholder='Enter Barcode' value={barcode} onChange={(e) => setbarcode(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSelectItem1(barcode) }} />
                  </div>
                  <div className='col-sm-3'>
                    <label>Select Product</label>
                    <Select options={products} value={item} onChange={handleSelectItem} />
                  </div>
                </div><br />

                <div className='row'>
                  <table className='table table-striped'>
                    <tr>
                      <th>Sr No</th>
                      <th>Date</th>
                      <th>Customer</th> {/* new column */}
                      <th>Product Name</th>
                      <th>Rate</th>
                      <th>Quantity</th>
                      <th>Total</th>
                      <th>Action</th>
                    </tr>
                    <tr>
                      <td colSpan={6}><b>Total</b></td>
                      <td><b>{totalamount}</b></td>
                      <td></td>
                    </tr>
                    {reportData.map((item, idx) =>
                      <tr key={item.id}>
                        <td>{idx + 1}</td>
                        <td>{moment(item.datetime).format('DD-MM-YYYY H:mm:ss A')}</td>
                        <td>{item.dealername || '-'}</td> {/* show customer */}
                        <td>{item.data.itemname}</td>
                        <td>{item.data.rate}</td>
                        <td>{item.data.quantity}</td>
                        <td>{item.data.total}</td>
                        <td>
                          <a onClick={() => handleDelete(item.id, item.data.quantity, item.data.itemid)} className="btn btn-sm btn-danger"><i className="fa fa-trash"></i></a>
                        </td>
                      </tr>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Dashboard;
